module.exports = "<h1>{{i18n + 'TITLE' | translate}}</h1>\n<p>{{i18n + 'MESSAGE' | translate}}</p>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/logout-screen/logout-screen.component.html
// module id = 819
// module chunks = 3